module.exports = __webpack_public_path__ + "static/media/amyan.e48f5d01.jpeg";